// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__yAYx6","logo":"Header_logo__9YFPc","buttons_row":"Header_buttons_row__Y+A7D"};